import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import getAxiosInstance from "./../../Utils/axios";
import Preview from "../../Components/Preview";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
});

export default function Media() {
    const [medias, setMedia] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [searchFilter, setSearchFilter] = useState("");
    const [searchByType, setSearchByType] = useState("");
    const [limit, setLimit] = useState(20);
    const [pageNumber, setPageNumber] = useState(0);
    const [totalMedia, setTotalMedia] = useState(0);

    let navigate = useNavigate();

    const getMedia = () => {
        let jsonData = {
            limit: limit,
            page: pageNumber * limit,
            search: searchFilter,
            filter_by: searchByType,
        };
        // converting (json --> form-urlencoded)
        const data = Object.keys(jsonData)
            .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
            .join("&");

        getAxiosInstance()
            .post("/admin/medias", data, {
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
            })
            .then((res) => {
                // Validating form
                setIsLoading(false);
                if (res.data.status === "success") {
                    // console.log(res.data);
                    setTotalMedia(res.data.totalCount);
                    setMedia(res.data.result);
                } else if (res.data.status === "error") Toast.fire({ icon: "error", title: res.data.message });
                else Toast.fire({ icon: "error", title: "Cannot process request" });
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    };

    useEffect(() => {
        getMedia();
    }, [limit, pageNumber, searchByType]);

    const changePage = ({ selected }) => setPageNumber(selected);

    const deleteMedia = (id) => {
        Swal.fire({
            icon: "warning",
            title: "Are you sure?",
            html: "<h5>This media will be deleted?</h5>",
            showCancelButton: true,
            confirmButtonText: `Delete`,
            confirmButtonColor: "#D14343",
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);

                const params = { id: id };

                // converting (json --> form-urlencoded)
                const data = Object.keys(params)
                    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
                    .join("&");

                getAxiosInstance()
                    .post("/admin/delete-media", data, {
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    })
                    .then((res) => {
                        // Validating form
                        setIsLoading(false);
                        if (res.data.status === "success") {
                            Toast.fire({ icon: "success", title: "Successfully deleted media" });
                            getMedia();
                        } else {
                            console.log(res.data);
                            Toast.fire({ icon: "error", title: "Unable to delete media" });
                        }
                    })
                    .catch((err) => {
                        Toast.fire({ icon: "error", title: "Unexpected Error" });
                        setIsLoading(false);
                        console.log(err);
                    });
            }
        });
    };

    return (
        <div>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-3">
                            <div className="col-sm-6">
                                <h1 className="m-0">Media List</h1>
                            </div>
                            <div className="col-sm-6">
                                <button
                                    type="button"
                                    className="btn btn-dark float-right"
                                    onClick={(e) => {
                                        window.location.href = "/broadcasting/media/add";
                                    }}
                                >
                                    Add Media
                                </button>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        {/* <h3 className="card-title">Media List</h3> */}
                                        <div class="card-tools row">
                                            <div className="col-8">
                                                <div className="input-group input-group-sm my-auto" style={{ width: "100%" }}>
                                                    <input type="text" name="table_search" className="form-control float-right" placeholder="Search" value={searchFilter} onChange={(e) => setSearchFilter(e.target.value)} />
                                                    <div className="input-group-append">
                                                        <button type="submit" className="btn btn-default" onClick={() => getMedia()}>
                                                            <i className="fas fa-search" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <select className="form-control" value={searchByType} onChange={(e) => setSearchByType(e.target.value)} style={{ height: 31, padding: 0 }}>
                                                    <option value="">All Media</option>
                                                    <option value="text">Text</option>
                                                    <option value="photo">Image</option>
                                                    <option value="video">Video</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 10 }}>SL No.</th>
                                                    <th>Title</th>
                                                    {(searchByType === "" || searchByType === "text") && <th>Text</th>}
                                                    {(searchByType === "" || searchByType === "photo") && <th style={{ width: 350 }}>Image</th>}
                                                    {(searchByType === "" || searchByType === "video") && <th>Video</th>}
                                                    <th style={{ width: 120 }}>Action</th>
                                                    {/* <th></th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading && (
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td colSpan={8}>Loading Media...</td>
                                                    </tr>
                                                )}
                                                {!isLoading && totalMedia === 0 && (
                                                    <tr style={{ textAlign: "center" }}>
                                                        <td colSpan={8}>No Media Found</td>
                                                    </tr>
                                                )}

                                                {medias?.map((media, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}.</td>
                                                        <td>{media.title}</td>
                                                        {(searchByType === "" || searchByType === "text") && <td>{media.text}</td>}
                                                        {(searchByType === "" || searchByType === "photo") && <td>{media.image?.length > 0 && media.image?.map((uro) => <Preview url={uro} type="photo" />)}</td>}
                                                        {(searchByType === "" || searchByType === "video") && <td>{media.video && <Preview url={media.video} type="video" />}</td>}
                                                        <td>
                                                            <div style={{ display: "flex" }}>
                                                                <button type="button" class="btn btn-success btn-sm ml-1" title="Schedule Broadcast" onClick={() => navigate(`/broadcasting/media/schedule/${media._id}`)}>
                                                                    <i className="fas fa-clock"></i>
                                                                </button>
                                                                <button type="button" class="btn btn-success btn-sm ml-1" title="Broadcast Now" onClick={() => navigate(`/broadcasting/media/now/${media._id}`)}>
                                                                    <i className="fas fa-rocket"></i>
                                                                </button>
                                                                <button type="button" class="btn btn-danger btn-sm ml-1" title="Delete" onClick={() => deleteMedia(media._id)}>
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                        {/* <td>{media._id}</td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="card-footer clearfix">
                                        {totalMedia > limit ? (
                                            <ReactPaginate
                                                previousLabel={"«"}
                                                nextLabel={"»"}
                                                pageCount={Math.ceil(totalMedia / limit)}
                                                onPageChange={changePage}
                                                containerClassName={"pagination pagination-sm m-0 float-right"}
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                // previousClassName={"previous"}
                                                previousLinkClassName={"page-link"}
                                                // nextClassName={"next"}
                                                nextLinkClassName={"page-link"}
                                                disabledClassName={"disabled"}
                                                activeClassName={"active"}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
